<template>
	<legend>
		{{text}}
		<div v-if="help">
			<div class="helpbub" v-if="showhelp" role="tooltip">
				<button type="button" class="helpx" @click="showhelp = false" tabindex="-1">X</button>
				<div class="helpmob"></div>{{help}}<div class="helpmob"></div>
				<button type="button" class="helpokay" @click="showhelp = false">Okay</button>
				<div class="helpmob"></div>
			</div>
			<button class="helpicon" type="button" 
			@click="showhelp ? showhelp = false : showhelp = true">?</button>
		</div>
	</legend>
</template>

<script>
export default {
	name: 'fieldLegend',
	data: function() {
		return {
			showhelp: false
		}
	},
	props: {
		text: String,
		help: String
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
	display: inline-block;
	margin-left: 0.25em;
}
h3 {
	position: relative;
	top: 0.125em;
	display: inline-block;
	margin: 0px;
	margin-right: 0.25em;
}
.helpicon:hover, .helpx:hover, .helpicon:focus, .helpx:focus {
	outline: 0px;
	opacity: 0.8;
	cursor: pointer;
}
.helpicon {
	position: relative;
	padding: 1px 6px;
	border: 0.125em solid;
	border-radius: 1em;
	color: #053d59;
	background-color: #FFF;
	font-family: ProbaPro;
	font-weight: bold;
}
.helpicon:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	background-color: #FFF;
	height: 0.125em;
	width: 0.5em;
	transform: rotate(45deg);
}
.helpbub {
	border: 1px solid #333333;
	border-radius: 0.25em;
	color: #FFF;
	background-color: #053d59;
	font-weight: normal;
	font-size: 0.9em;
	z-index: 1;
}
.helpx {
	float: right;
	padding: 0px;
	border: 0px;
	color: #FFF;
	background-color: transparent;
	font-family: ProbaPro;
	transform: scale(1.75, 1.5) translateX(0.25em);
}
@media screen and (min-width: 661px) {
	.helpbub {
		position: absolute;
		top: -250%;
		right: -8em;
		padding: 0.5em 1em;
		width: 16em;
		transform: translateY(-50%);
	}
	.helpmob, .helpokay {
		display: none;
	}
	.helpbub:after {
		content: '';
		position: absolute;
		top: 99%;
		left: 50%;
		border-right: 1px solid #333333;
		border-bottom: 1px solid #333333;
		background-color: inherit;
		width: 0.5em;
		height: 0.5em;
		transform: rotate(45deg) translateY(-50%);
	}
	.helpx {
		transform: scale(1.75, 1.5) translateX(0.25em);
	}
}
@media screen and (max-width: 660px) {
	.helpbub {
		position: fixed;
		top: 50%;
		right: 50%;
		padding: 0.5em 7.5%;
		width: 60%;
		text-align: center;
		transform: translate(50%, -50%);
	}
	.helpmob {
		display: block;
		height: 2em;
	}
	.helpx {
		transform: scale(1.75, 1.5) translateX(1em);
	}
	.helpokay {
		padding: 1em 3em;
		border: 0px;
		border-radius: 2em;
		color: #FFF;
		background-color: #e51635;
		font-family: ProbaPro;
		font-size: 1em;
		font-weight: bold;
	}
	.helpokay:hover, .helpokay:focus {
		background-color: #ba112d;
		outline: 0px;
		cursor: pointer;
	}
}
</style>
